import {Canvg} from "canvg";

export function imageToBase64(url: string, callback: (result: any) => any) {
    const middlewareUrl = "/media" + url;
    url && fetch(middlewareUrl)
        .then((response) => response.blob())
        .then((blob) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => callback(reader.result);
        });
}

export async function svgToDataUri(svgString: string) {
    try {
        const canvas: HTMLCanvasElement = document.createElement("canvas")
        const context = canvas.getContext("2d")
        if (context) {
            const v = Canvg.fromString(context, svgString.trim())
            await v.render()
            return canvas.toDataURL("image/png")
        }
    } catch (error) {
        console.error("Error occured:", error)
        return ""
    }
}